import { Button, Dialog, Icon, IconButton } from '@ui'
import api, { IEmployee, IFloorDetails, IFloorMapSpace, ISpace } from '@api'
import cx from 'classnames'
import css from './spaceCatalogHeader.module.scss'
import React, { useEffect, useState } from 'react'
import { useFloor, useMapInit } from '@providers/mapProvider'
import { isMeetingRoom } from '@utils'
enum AllTabs {
  ABOUT = 'about',
  ASSIGNED = 'assigned',
  UPLOAD = 'upload',
}
import { Tooltip2 } from '@blueprintjs/popover2'
import defaultImage from '../../../assets/header_desk.svg'
import EmployeeShareDialog from '../spaceShareDialog'
import getSpaceAsset from 'components/SpaceTypeManagement/hooks/useSpaceAsset'
import useSettings from 'components/NewSettings/hooks/useSettings'
import { QRCodeDialog } from '../QRCodeDialog'

export default function SpaceCatalogHeader({
  setSplitScreen,
  floorDetails,
  updateDefaultImage,
}: Readonly<{
  setSplitScreen: (value: boolean) => void
  floorDetails: IFloorDetails
  updateDefaultImage: boolean
}>) {
  const floor = useFloor()
  const settings = useSettings()
  let space: IFloorMapSpace | undefined
  const [image, setImage] = useState('')
  const [isQRCodePopoverOpen, setIsQRCodePopoverOpen] = useState(false)
  let spaceId: string | undefined
  if (floor.selection?.count === 1) {
    space = floor.spaces.byId[Object.keys(floor.selection?.items || [])[0]]
    spaceId = space?.id
  }
  const [isSharePopoverOpen, setIsSharePopoverOpen] = useState(false)
  const [employeeList, setEmployeeList] = useState<IEmployee[]>([])
  useEffect(() => {
    getSpaceAsset(spaceId).then((assets) => {
      setImage(assets.filter((image) => image.isDefault)[0]?.url)
    })
  }, [spaceId, updateDefaultImage])

  const isShowQRCode = () =>
    settings.qrCodeEnabled &&
    space?.usageType &&
    floor?.printableQrCodeUsageTypes?.includes(space?.usageType.name)

  const map = useMapInit()

  return (
    <>
      <header>
        <IconButton
          className={css.closeButton}
          round={false}
          minimal
          iconName="close"
          onClick={() => {
            floor?.selection?.clear()
            setSplitScreen(false)
          }}
        />
      </header>
      <div className={css.spaceImage}>{getSpaceImage(image, space as ISpace)}</div>

      <div className={css.spaceDetails}>
        <span className={css.usageType}>{space?.usageType?.displayName}</span>
        <span className={css.spaceIcons}></span>
        {isShowQRCode() && (
          <Tooltip2 content="Download QR code">
            <span onClick={() => setIsQRCodePopoverOpen(true)}>
              <Icon light name="qrcode" className={cx('fa-light', css.spaceIcons)} />
            </span>
          </Tooltip2>
        )}
        <Tooltip2 content="Share space">
          <span
            onClick={() => {
              setIsSharePopoverOpen(true)
              setEmployeeList([])
            }}>
            <Icon light name="share-nodes" className={cx('fa-light', css.spaceIcons)} />
          </span>
        </Tooltip2>
      </div>
      <div className={css.spaceType}>{space?.spaceType?.displayName}</div>
      <div>
        <div className={css.space}>
          <Icon light name="chair-office" className={cx('fa-light')} />
          <span
            className={css.spaceCode}
            onClick={async () => {
              const coordinates =
                spaceId && (await api.space.getSpaceCoordinates(spaceId as string))
              if (coordinates) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                map?.current?.zoomTo(coordinates)
              }
            }}>
            {space?.externalId}
          </span>
        </div>
        <div className={css.floor}>
          <Icon light name="map-location" className={cx('fa-light')} />
          <span className={css.floorName}>{geBuildingDetails(floorDetails)}</span>
        </div>
      </div>
      <EmployeeShareDialog
        spaces={space ? [space] : []}
        assignmentPlanId={floor.apId}
        setIsSharePopoverOpen={setIsSharePopoverOpen}
        isSharePopoverOpen={isSharePopoverOpen}
        employeeList={employeeList}
        setemployeeList={setEmployeeList}
      />
      {spaceId && (
        <QRCodeDialog
          isQRCodePopoverOpen={isQRCodePopoverOpen}
          setIsQRCodePopoverOpen={setIsQRCodePopoverOpen}
          spaceIds={[spaceId]}
        />
      )}
    </>
  )
}
const geBuildingDetails = (floor: IFloorDetails) => {
  return `${floor?.name || ''}, ${floor?.building?.name || ''},
     ${floor?.building?.city || ''},
     ${floor?.building?.state || ''}`
}

export const getSpaceImage = (image: string, space: ISpace) => {
  return (
    <>
      {image ? (
        <img className={css.image} src={image} />
      ) : space && isMeetingRoom(space.spaceType) ? (
        <Icon light name="screen-users" className={cx('fa-light', css.image)} />
      ) : (
        <img className={css.image} src={defaultImage} />
      )}
    </>
  )
}
